import { DeleteOutlined } from "@ant-design/icons";
import { Badge, Button, Card, Col, Popover, Row, Typography } from "antd";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CardComponent from "../Card/card.components";
import Loader from "../loader/loader";
import { loadSingleSale } from "../../redux/actions/sale/detailSaleAction";
import { deleteSale } from "../../redux/actions/sale/deleteSaleAction";
import ReturnSaleInvoiceList from "../Card/saleInvoice/ReturnSaleInvoiceList";
import SaleProductListCard from "../Card/saleInvoice/SaleProductListCard";
import TransactionSaleList from "../Card/saleInvoice/TransactionSaleList";
import PackingSlip from "../Invoice/PackingSlip";
import PosPrint from "../Invoice/PosPrint";
import SaleInvoice from "../Invoice/SaleInvoice";
import moment from "moment";
import "./sale.css";

const DetailSale = () => {
	const { id } = useParams();
	let navigate = useNavigate();
	
	// Get document type from URL query parameter
	const urlParams = new URLSearchParams(window.location.search);
	const documentType = urlParams.get('type') || 'sale';

	//dispatch
	const dispatch = useDispatch();
	const sale = useSelector((state) => state.sales.sale);
	const {
		status,
		totalPaidAmount,
		totalReturnAmount,
		dueAmount,
		singleSaleInvoice,
		returnSaleInvoice,
		transactions,
		totalUnitMeasurement,
	} = sale ? sale : {};

	const [showSaleInvoice, setShowSaleInvoice] = useState(false);
  const [showPackingSlip, setShowPackingSlip] = useState(false);
  const [showPosPrint, setShowPosPrint] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

	//Delete Customer
	const onDelete = () => {
		try {
			dispatch(deleteSale(id));

			setVisible(false);
			toast.warning(`Sale : ${sale.id} is removed `);
			return navigate("/salelist");
		} catch (error) {
			console.log(error.message);
		}
	};
	// Delete Customer PopUp
	const [visible, setVisible] = useState(false);

	const handleVisibleChange = (newVisible) => {
		setVisible(newVisible);
	};

	useEffect(() => {
		// Get document type from URL
		const urlParams = new URLSearchParams(window.location.search);
		const docType = urlParams.get('type') || 'sale';
		
		dispatch(loadSingleSale(id, docType));
		
		// Check if user is on mobile
		const checkMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};
		
		checkMobile();
		window.addEventListener('resize', checkMobile);
		
		return () => window.removeEventListener('resize', checkMobile);
	}, [id]);

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	const docLabel = documentType === "quotation" ? "Quotation" : documentType === "challan" ? "Delivery Challan" : "Sale Invoice";
	const invoiceRef = singleSaleInvoice?.prefix && singleSaleInvoice?.invoice_number
		? `${singleSaleInvoice.prefix}${singleSaleInvoice.invoice_number}`
		: `#${singleSaleInvoice?.id}`;

	return (
		<div className="sale-detail-page">
			<div className="sale-detail-wrap">
				{singleSaleInvoice ? (
					<Fragment key={singleSaleInvoice.id}>
						<Card bordered={false} className="sale-detail-card">
							<div className="sale-detail-header">
								<h5 className="sale-detail-title">
									<i className="bi bi-receipt" aria-hidden />
									<span className="sale-detail-name">
										{docLabel} {invoiceRef}
									</span>
								</h5>
								<div className="sale-detail-actions">
									{documentType === "sale" && (
										<Link to={`/sale/return/${id}`}>
											<Button type="primary" shape="round">
												Return Product
											</Button>
										</Link>
									)}
									<Popover
										content={
											<a onClick={onDelete}>
												<Button type="primary" danger>Yes Please !</Button>
											</a>
										}
										title="Are you sure you want to delete ?"
										trigger="click"
										open={visible}
										onOpenChange={handleVisibleChange}>
										<Button type="danger" shape="round" icon={<DeleteOutlined />} aria-label="Delete" />
									</Popover>
									<SaleInvoice data={singleSaleInvoice} autoShow={isMobile} documentType={documentType} />
									{documentType === "sale" && (
										<>
											<PackingSlip data={singleSaleInvoice} />
											<PosPrint data={singleSaleInvoice} />
										</>
									)}
								</div>
							</div>
							<div className="sale-detail-body">
								<Row gutter={[16, 16]} justify="space-around">
									<Col xs={24} md={11}>
										<CardComponent title="Initial Invoice Information">
											<div className='d-flex justify-content-between'>
												<div>
													<p>
														<Typography.Text strong>
															{documentType === 'quotation' ? 'Quotation' : documentType === 'challan' ? 'Challan' : 'Sale'} Date :
														</Typography.Text>{" "}
														<strong>
															{moment(singleSaleInvoice.date).format("ll")}
														</strong>
													</p>
													<p>
														<Typography.Text strong>
															Customer :{" "}
														</Typography.Text>{" "}
														<Link
															to={`/customer/${singleSaleInvoice.customer.id}`}>
															<strong>{singleSaleInvoice.customer.name}</strong>
														</Link>
													</p>

													<p>
														<Typography.Text strong>
															Total Amount :
														</Typography.Text>{" "}
														<strong>{singleSaleInvoice.total_amount}</strong>
													</p>
													<p>
														<Typography.Text strong>Discount :</Typography.Text>{" "}
														<strong>{singleSaleInvoice.discount}</strong>
													</p>
													{documentType === 'sale' && (
														<>
															<p>
																<Typography.Text strong>
																	Paid Amount :
																</Typography.Text>{" "}
																<strong>{singleSaleInvoice.paid_amount}</strong>
															</p>
															<p>
																<Typography.Text strong>
																	Due Amount :
																</Typography.Text>{" "}
																<strong style={{ color: "red" }}>
																	{" "}
																	{singleSaleInvoice.due_amount}
																</strong>
															</p>
															<p>
																<Typography.Text strong>Profit :</Typography.Text>{" "}
																<strong>{singleSaleInvoice.profit}</strong>
															</p>
														</>
													)}
												</div>

												<div className='me-2'></div>
											</div>
										</CardComponent>
									</Col>
									<Col xs={24} md={12}>
										<Badge.Ribbon
											text={status}
											color={status === "PAID" ? "green" : "red"}>
											<CardComponent title="Update Invoice Information">
												<div>
													<p>
														<Typography.Text strong>
															Total Paid Amount :
														</Typography.Text>{" "}
														<strong>{totalPaidAmount}</strong>
													</p>

													<p>
														<Typography.Text strong>
															Total Return Amount:
														</Typography.Text>{" "}
														<strong>{totalReturnAmount}</strong>
													</p>

													<p>
														<Typography.Text strong>
															Due Amount :
														</Typography.Text>{" "}
														<strong style={{ color: "red" }}>
															{dueAmount}
														</strong>
													</p>
													<p>
														<Typography.Text strong>
															Total Unit Measurement :
														</Typography.Text>{" "}
														<strong>{totalUnitMeasurement}</strong>
													</p>
												</div>
											</CardComponent>
										</Badge.Ribbon>
									</Col>
								</Row>

							</div>
						</Card>
						<SaleProductListCard list={singleSaleInvoice.saleInvoiceProduct} />

						{/* Only show returns and transactions for sales */}
						{documentType === 'sale' && (
							<>
								<ReturnSaleInvoiceList list={returnSaleInvoice} />
								<TransactionSaleList list={transactions} />
							</>
						)}
					</Fragment>
				) : (
					<Loader />
				)}
			</div>
		</div>
	);
};

export default DetailSale;
